import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SocialTagsService } from 'src/app/core/services/social-tags-service.service';
import { environment } from 'src/environments/environment';
import { Y2021Config } from './y2021'

@Component({
  selector: 'app-y2021',
  templateUrl: './y2021.component.html',
  styleUrls: ['./y2021.component.scss']
})
export class Y2021Component implements OnInit {

  config = Y2021Config;

  constructor(
    private meta: Meta,
    private title: Title,
    private tagsService: SocialTagsService,
  ) {
    this.title.setTitle('เทศกาลลดหย่อนภาษีประจำปี รวมทุกผลิตภัณฑ์ประหยัดภาษี - iTAX');
    this.meta.updateTag({
      name: 'description',
      content: 'iTAX เปิดเทศกาลลดหย่อนภาษีสำหรับปี 2564 รวบรวมผลิตภัณฑ์ด้านการเงินทั้งระยะสั้น และระยะยาว เพื่อให้คุณประหยัดภาษีกว่าเดิม ทั้งบุคคลธรรมดา และนิติบุคคล'
    });
    this.tagsService.setTitleAndTags({
      tagSocialDescription: 'รวมผลิตภัณฑ์ลดหย่อนภาษี เพื่อให้คุณประหยัดภาษีสูงสุด',
      tagSocialTitle: 'iTAX 2021 เทศกาลลดหย่อนภาษีประจำปี',
      urlPrefix:  environment.mainBaseUrl
    });
  }

  ngOnInit(): void {
  }

}
